import React, { Component } from 'react';

class HeadingPage extends Component {

    constructor() {
        super();

        this.state = {
            title: '',
            duplicates: []
        }
    }

    componentDidMount() {
        this.setState({
            title: this.props.title + '_'
        }, () => {
            this.setDuplicates();
        });
    }

    setDuplicates() {
        let duplicates = [];
        for (let i = 1; i <= 4; i++) {
            duplicates.push(<span key={i} className="move-me">{this.state.title}</span>);
        }

        this.setState({
            duplicates: duplicates
        });
    }

    render() {
        return (
            <section className="heading-page" {...this.props}>
                <div className="trigger" />
                <div className="sub-heading">
                    <h2 dangerouslySetInnerHTML={{__html: this.state.title}} className="text-center text-lg-left" />
                    {this.state.duplicates}
					{this.props.children}
                </div>
            </section>
        );
    }

}

export default HeadingPage;


// WEBPACK FOOTER //
// ./src/js/views/HeadingPage.js